import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "内容导航",
    links: [
      { label: "选择指南", href: "/category/selection-guide" },
      { label: "观影礼仪", href: "/category/etiquette" },
      { label: "隐私保护", href: "/category/privacy" },
      { label: "合规运营", href: "/category/compliance" },
    ],
  },
  {
    title: "帮助支持",
    links: [
      { label: "常见问题", href: "/category/faq-category" },
      { label: "关于我们", href: "/about" },
      { label: "联系我们", href: "/about" },
    ],
  },
  {
    title: "法律声明",
    links: [
      { label: "隐私政策", href: "/about" },
      { label: "使用条款", href: "/about" },
      { label: "免责声明", href: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading font-semibold text-background-50 whitespace-nowrap cursor-pointer">
              私享观影指南
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              专业、客观、值得信赖的成人影院资讯平台，为成年消费者提供全面的观影指导。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 私享观影指南. 保留所有权利.
          </p>
          <p className="text-xs text-background-400">
            本站内容仅供成年人参考，未成年人请勿浏览。
          </p>
        </div>
      </div>
    </footer>
  );
}